<template>
  <div>
    <v-flex>
      <v-snackbar
        v-model="dialog.snackbar"
        top
        right
        color="#ff64ad">
        <span class="body-1 font-weight-light white--text"
          v-html="message.success">
        </span>

        <template v-slot:action="{ attrs }">
          <v-btn
            class="body-1 font-weight-bold text-capitalize"
            color="white"
            icon
            v-bind="attrs"
            @click="dialog.snackbar = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog.zoom"
        @keydown.esc="dialog.zoom = false"
        :fullscreen="dialog.fullscreen"
        width="1000"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Swafoto
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.zoom = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="Object.keys(detail).length > 0"
            class="pt-2 pa-4">
            <v-card
              flat
              style="border-radius: 10px;">
              <v-img
                contain
                alt="vuetify"
                gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                :src="detail.request.uru_image">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.approve"
        @keydown.esc="dialog.approve = false"
        :fullscreen="dialog.fullscreen"
        width="500"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Setujui Pengajuan Perubahan Data Akun
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.approve = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="Object.keys(detail).length > 0"
            class="pt-2 body-1 line-text-second">
            <div
              class="font-weight-light black---text mb-2">
              Apakah Anda yakin mensetujui pengajuan perubahan data akun <b>{{ detail.request.uru_fullname }}</b> ?
            </div>

            <v-alert 
              type="error" 
              text dense prominent 
              class="mt-6"
              v-show="message.error.length > 0">
              {{  message.error }}
            </v-alert>
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-0"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              v-on:keyup.enter="save()"
              @click="save()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.approve = false">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.reject"
        @keydown.esc="dialog.reject = false"
        :fullscreen="dialog.fullscreen"
        width="750"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Tolak Perubahan Elemen Data Akun
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.reject = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="Object.keys(detail).length > 0"
            class="pt-2 body-1 line-text-second">
            <div
              class="font-weight-light black---text mb-4">
              Apakah Anda yakin menolak pengajuan perubahan data akun <b>{{ detail.request.uru_fullname }}</b> ?
            </div>

            <div>
              <div class="body-2 font-italic font-weight-light mb-2">
                *Jika Anda menolak pengajuan perubahan data akun, silahkan masukkan alasan penolakan dibawah ini:
              </div>

              <quill-editor 
                ref="myTextEditor"
                :options="{
                  placeholder: 'Contoh. Data KTP tidak sesuai, mohon di sesuaikan dengan KTP asli.'
                }"
                v-model="form.note">
              </quill-editor>
            </div>

            <v-alert 
              type="error" 
              text dense prominent 
              class="mt-6"
              v-show="message.error.length > 0">
              {{  message.error }}
            </v-alert>
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-0"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              v-on:keyup.enter="save()"
              @click="save()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.reject = false">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <section>
        <v-row v-if="process.load && Object.keys(detail).length < 1">
          <v-col 
            cols="12"
            md="3"
            class="pb-0">
            <v-skeleton-loader
              type="image, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>

          <v-col 
            cols="12"
            md="9"
            class="pb-0">
            <v-skeleton-loader
              type="article, list-item-three-line, article, list-item-three-line, article, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <div v-if="!process.load && Object.keys(detail).length > 0"
          class="pb-0">
          <v-row>
            <v-col 
              cols="12"
              md="3"
              class="pb-0">
              <div @click="$router.go(-1)"
                class="d-flex align-center color-first cursor-pointer mb-4">
                <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
            
                <span class="body-1 ml-1">
                  Kembali
                </span>
              </div>

              <v-card
                flat
                class="mb-2"
                style="border-radius: 10px;">
                <v-img
                  contain
                  alt="vuetify"
                  gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                  :src="detail.request.uru_image">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-row>
                  </template>

                  <v-icon 
                    @click="dialog.zoom = true"
                    class="cursor-pointer pa-2"
                    size="30"
                    color="white"
                    style="position: absolute;
                          top: 0px;
                          right: 0px;">
                    mdi-fullscreen
                  </v-icon>

                  <div
                    class="title pa-4 white--text"
                    style="position: absolute;
                          bottom: 0px;">
                    Swafoto
                  </div>
                </v-img>
              </v-card>

              <v-card
                flat>
                <v-card-text
                  class="body-2 font-italic font-weight-light px-0 line-text-second mb-1"
                  style="opacity: 60%;">
                  *Silahakn periksa data pengajuan akun berikut, dan selanjutnya untuk di verifikasi bahwa akun tersebut sudah valid.
                </v-card-text>

                <v-card-text
                  class="pa-0">
                  <v-btn
                    @click="dialog.approve = true; form.status = 'DISETUJUI';"
                    block
                    elevation="0"
                    color="#ff64ad"
                    class="body-2 font-weight-bold text-capitalize white--text d-flex align-center">
                    <v-icon>mdi-account-check</v-icon>

                    <v-spacer />

                    <span>
                      Setujui Perubahan Elemen Data Akun
                    </span>
                  </v-btn>
                </v-card-text>

                <v-card-text
                  class="px-16 d-flex align-center">
                  <v-divider />

                  <div
                    class="mx-4">
                    Atau
                  </div>

                  <v-divider />
                </v-card-text>

                <v-card-text
                  class="pa-0">
                  <v-btn
                    @click="dialog.reject = true; form.status = 'DITOLAK';"
                    block
                    elevation="0"
                    outlined
                    color="#ff64ad"
                    class="body-2 font-weight-bold text-capitalize d-flex align-center">
                    <v-icon>mdi-account-cancel</v-icon>

                    <v-spacer />

                    <span>
                      Tolak Perubahan Elemen Data Akun
                    </span>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col 
              cols="12"
              md="9"
              class="pb-0">
              <v-card
                flat
                class="ml-3">
                <v-card-title
                  class="text-h5 font-weight-bold px-0 mt-4 mb-1">
                  {{ detail.request.uru_fullname }}
                </v-card-title>

                <v-card-subtitle
                  class="body-1 font-weight-light red--text px-0 d-flex align-center mb-4">
                  <v-icon color="red" class="mr-1">mdi-account-cancel</v-icon>

                  {{ detail.request.uru_status }}
                </v-card-subtitle>

                <v-card-text
                  class="px-0">
                  <v-divider
                    style="border: 3px solid #ff64ad;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2">
                    Data Pribadi
                  </div>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Nama Lengkap
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_fullname !== detail.current.fullname ? 'red--text' : ''">
                      : {{ detail.request.uru_fullname }}
                    </v-col>
                  </v-row>
                  
                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      KK (Kartu Keluarga)
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_kk !== detail.current.kk ? 'red--text' : ''">
                      : {{ detail.request.uru_kk === '' ? '-' : detail.request.uru_kk }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      NIK
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_nik !== detail.current.nik ? 'red--text' : ''">
                      : {{ detail.request.uru_nik === '' ? '-' : detail.request.uru_nik }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Email
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_email !== detail.current.email ? 'red--text' : ''">
                      : {{ detail.request.uru_email === '' ? '-' : detail.request.uru_email }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-7">
                    <v-col
                      cols="3"
                      class="py-0">
                      Telepon
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_phone !== detail.current.phone ? 'red--text' : ''">
                      : {{ detail.request.uru_phone === '' ? '-' : detail.request.uru_phone }}
                    </v-col>
                  </v-row>

                  <v-divider
                    style="border: 3px solid #ff64ad;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2">
                    Alamat Lengkap
                  </div>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Dukuh
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_dukuh !== detail.current.dukuh ? 'red--text' : ''">
                      : {{ detail.request.uru_dukuh === '' ? '-' : detail.request.uru_dukuh }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      RT / RW
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : 
                      <span
                        :class="detail.request.uru_rt !== detail.current.rt ? 'red--text' : ''">
                        {{ detail.request.uru_rt === '' ? '-' : detail.request.uru_rt }}
                      </span> / 

                      <span
                        :class="detail.request.uru_rw !== detail.current.rw ? 'red--text' : ''">
                        {{ detail.request.uru_rw === '' ? '-' : detail.request.uru_rw }}
                      </span>
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Kelurahan
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_kelurahan_name !== detail.current.kelurahan_name ? 'red--text' : ''">
                      : {{ detail.request.uru_kelurahan_name === '' ? '-' : detail.request.uru_kelurahan_name }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Kecamatan
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0"
                      :class="detail.request.uru_kecamatan_name !== detail.current.kecamatan_name ? 'red--text' : ''">
                      : {{ detail.request.uru_kecamatan_name === '' ? '-' : detail.request.uru_kecamatan_name }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card
                flat
                class="ml-3"
                style="border: 3px solid orange; border-radius: 15px;">
                <v-card-text
                  class="pb-1 pt-3"
                  style="background: #ffa5001a;">
                  <v-card-title
                    class="text-h5 font-weight-bold black--text px-0 pt-0 mb-1">
                    Data Sebelum Pengajuan
                  </v-card-title>

                  <v-card-subtitle
                    class="body-1 font-weight-light black--text px-0 d-flex align-center mb-4"
                    style="opacity: 60%;">
                    Berikut adalah data Anda sebelum pengajuan perubahan elemen data:
                  </v-card-subtitle>
                  
                  <v-divider
                    style="border: 3px solid orange;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2">
                    Data Pribadi
                  </div>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Nama Lengkap
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.fullname }}
                    </v-col>
                  </v-row>
                  
                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      KK (Kartu Keluarga)
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.kk === '' ? '-' : detail.current.kk }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      NIK
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.nik === '' ? '-' : detail.current.nik }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Email
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.email === '' ? '-' : detail.current.email }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-7">
                    <v-col
                      cols="3"
                      class="py-0">
                      Telepon
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.phone === '' ? '-' : detail.current.phone }}
                    </v-col>
                  </v-row>

                  <v-divider
                    style="border: 3px solid orange;
                        border-radius: 50px;
                        width: 100px;" />

                  <div
                    class="body-1 font-weight-bold black--text my-2">
                    Alamat Lengkap
                  </div>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Dukuh
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.dukuh === '' ? '-' : detail.current.dukuh }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      RT / RW
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.rt === '' ? '-' : detail.current.rt }} / {{ detail.current.rw === '' ? '-' : detail.current.rw }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Kelurahan
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.kelurahan_name === '' ? '-' : detail.current.kelurahan_name }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-2">
                    <v-col
                      cols="3"
                      class="py-0">
                      Kecamatan
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0">
                      : {{ detail.current.kecamatan_name === '' ? '-' : detail.current.kecamatan_name }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
    </v-flex>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,
          zoom: false,
          approve: false,
          reject: false
        },
        detail: {},
        form: {
          id: '',
          status: '',
          note: ''
        },
        process: {
          load: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`user/user_request_update/detail`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.load = false
            
            this.detail = res.data

            this.form.id = this.$route.params.id
          }
        })
      },
      async save () {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post('user/user_request_update/update_status', {
          data: this.form
        })
        .then(response => {
          let res = response.data

          this.process.form = false

          if (res.code === 200) {
            this.dialog.snackbar = true

            this.message.success = res.message

            this.$router.push('/user')
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>